type EnumLiteralsOf<T extends unknown> = T[keyof T];
export const LogARStatus = Object.freeze({
  OUTSTANDING_DEBT: 1 as const,
});

export type LogARStatus = EnumLiteralsOf<typeof LogARStatus>;
